// This file is automatically generated. Do not edit manually.

import { CustomerOrderChangeView } from "src/api/generated/erp/db/types/tables/customerOrderChangeView";
import { CustomerOrderChangeObjectType } from "src/api/generated/erp/db/types/enums/customerOrderChangeObjectType";
import { CustomerOrderChange } from "src/api/generated/erp/db/types/tables/customerOrderChange";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderChangeApi {
	export async function getCustomerOfferOrderChanges(args: {
		customerOrderOfferId: number;
	}): Promise<Array<CustomerOrderChangeView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderChanges/getCustomerOfferOrderChanges",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
			},
		});
		return response as Array<CustomerOrderChangeView>;
	}

	export async function getCustomerOrderChanges(args: {
		objectType: CustomerOrderChangeObjectType;
		objectId: number;
	}): Promise<Array<CustomerOrderChangeView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderChanges/getCustomerOrderChanges",
			method: "POST",
			data: {
				objectType: args.objectType,
				objectId: args.objectId,
			},
		});
		return response as Array<CustomerOrderChangeView>;
	}

	export async function insert(args: { customerOrderChange: CustomerOrderChange }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderChanges/insert",
			method: "POST",
			data: {
				customerOrderChange: args.customerOrderChange,
			},
		});
		return response as number;
	}

	export async function updateCustomerOfferOrderChange(args: {
		customerOrderChange: CustomerOrderChange;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderChanges/updateCustomerOfferOrderChange",
			method: "POST",
			data: {
				customerOrderChange: args.customerOrderChange,
			},
		});
		return response as void;
	}

	export async function update(args: { customerOrderChange: CustomerOrderChange }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderChanges/update",
			method: "POST",
			data: {
				customerOrderChange: args.customerOrderChange,
			},
		});
		return response as void;
	}

	export async function delete_(args: { customerOrderChangeId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderChanges/delete",
			method: "POST",
			data: {
				customerOrderChangeId: args.customerOrderChangeId,
			},
		});
		return response as void;
	}
}
